import { styled } from "@material-ui/core";
import { div, DragNDropUpload, Flex, SelectFile } from "lqx-react";
import * as React from "react";
import { useEffect } from "react";

export const UploadFile = ({ $file, $isValidFile, allowedExtensions = ".pdf" }) => {
    const hasSelectedFile = !!$file.value;
    const isValidFile = hasSelectedFile && allowedExtensions.split(',').filter(ext => $file.value.name.endsWith(ext.trim())).length > 0;

    useEffect(() => $isValidFile.set(hasSelectedFile && isValidFile), [ hasSelectedFile, isValidFile ])

    return (
        <UploadContainer>
            { hasSelectedFile && !isValidFile && <UploadWarning>Your file is in incorrect format</UploadWarning> }
            <DragNDropUpload $file={ $file } />
            { $file.value &&
                <Flex column center>
                    <UploadedFileName>{ $file.value.name }</UploadedFileName>
                </Flex> }
            <Flex center>
                <span>Drag and drop here or <UploadSelectFile lqx-qa-id="select policy file" label="select file" $value={ $file } accept={ allowedExtensions } /> to upload your file.</span>
            </Flex>
        </UploadContainer>
    );
}

const UploadContainer = div({
    backgroundColor: 'white',
    padding: '30px',
    paddingBottom: '100px'
});

const UploadWarning = div({
    marginTop: '15px',
    color: '#fccb4f'
});

const UploadedFileName = div({
    color: '#4197d6',
    fontWeight: 800
});

const UploadSelectFile = styled(SelectFile)({
    border: 'none',
    display: 'inline-block',
    padding: 0,
    '& .filename': {
        display: 'none'
    },
    '& .MuiSvgIcon-root': {
        display: 'none'
    },
    '& div': {
        color: '#4197d6',
        fontSize: 15
    },
    cursor: 'pointer'
});
